import {ORIENTATION, SIZE} from '@/utils/constants/globalStyle'
import {Toggle as PepsiCoDsToggle} from 'pepsico-ds'
import './toggleButtonStyles.scss'

/**
 * Toggle component renders a toggle switch with customizable properties.
 *
 * @param {Object} props - The properties object.
 * @param {boolean} [props.value=false] - The current value of the toggle.
 * @param {(value: boolean) => void} [props.updateValue=() => {}] - The function to call when the toggle value changes.
 * @param {Object} [props.uiSchema={}] - The UI schema object containing additional properties.
 * @param {('small'|'medium')} [props.uiSchema.size=SIZE.MEDIUM] - The size of the toggle.
 * @param {string} [props.uiSchema.className=''] - Additional class names for the toggle.
 * @param {boolean} [props.uiSchema.isDark=true] - Flag to set the toggle to dark mode.
 * @param {string} [props.uiSchema.defaultValue=''] - The default value of the toggle.
 * @param {string} [props.uiSchema.label=''] - The label for the toggle.
 * @param {string} [props.uiSchema.variant=ORIENTATION.HORIZONTAL] - The variant of the toggle.
 * @param {boolean} [props.uiSchema.showCheckedIcon=true] - Whether to show the checked icon.
 * @param {boolean} [props.disabled=false] - Flag to disable the toggle.
 * @param {string} [props.id=''] - Optional additional id to apply to the toggle.
 * @param {string} [props.title=''] - Fallback title used as the label.
 *
 * @returns {JSX.Element} The rendered Toggle component.
 */
export default function Toggle({
  value = false,
  updateValue = () => {},
  uiSchema = {},
  disabled = false,
  id = '',
  title = '',
}) {
  const {
    size = SIZE?.MEDIUM,
    className,
    isDark = true,
    // defaultValue,
    label = title,
    variant = ORIENTATION.HORIZONTAL,
    showCheckedIcon = true,
  } = uiSchema

  return (
    <div className="toggle-btn " data-testid={`toggle` + (id ? `_${id}` : '')}>
      <PepsiCoDsToggle
        data-testid={`toggle` + (id ? `_${id}` : '')}
        id={`toggle` + (id ? `_${id}` : '')}
        label={label}
        onUpdate={updateValue}
        size={size}
        checked={value}
        value={value ? 'Yes' : 'No'}
        disabled={disabled}
        className={className}
        isDark={isDark}
        variant={variant}
        showCheckedIcon={showCheckedIcon}
      />
    </div>
  )
}
